import SvgIcon from '@mui/material/SvgIcon';
import type { SxProps } from "@mui/material";
import React from "react";

export const GroupOfPeople5: React.FC<{ sx?: SxProps }> = ({ sx }) => {
    return (
        <SvgIcon sx={sx}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 93.067 84.5"
            >
                <g>
                    <path
                        d="M488.685,21.339c.37-.019.741-.029,1.113-.029s.744.01,1.113.029a10.7,10.7,0,1,0-2.226,0"
                        transform="translate(-428.957)"
                        fill="#e85317"
                    />
                    <path
                        d="M467.9,242.106a13.228,13.228,0,0,1,3.9,9.415,13.549,13.549,0,0,1-.086,1.518h1.274a16.505,16.505,0,0,1,2.105-1.858,18.84,18.84,0,0,1,5.49-2.789,13.376,13.376,0,0,1-2.9-2.2,13.319,13.319,0,0,1-1.35-17.254,18.943,18.943,0,0,0-2.375-.294q-.578-.035-1.168-.035t-1.168.035a16.4,16.4,0,0,0-11.518,5.327,13.043,13.043,0,0,1,1.821,4.685,13.236,13.236,0,0,1,5.972,3.452"
                        transform="translate(-411.952 -204.681)"
                        fill="#e85317"
                    />
                    <path
                        d="M215.272,21.339c.37-.019.741-.029,1.113-.029s.744.01,1.113.029a10.7,10.7,0,1,0-2.227,0"
                        transform="translate(-184.159)"
                        fill="#e85317"
                    />
                    <path
                        d="M241.256,228.607q-.59,0-1.168.035a18.944,18.944,0,0,0-2.375.294,13.319,13.319,0,0,1-1.35,17.254,13.375,13.375,0,0,1-2.9,2.2,18.837,18.837,0,0,1,5.49,2.789,16.5,16.5,0,0,1,2.105,1.858h1.274a13.533,13.533,0,0,1-.086-1.518,13.284,13.284,0,0,1,11.264-13.158,13.45,13.45,0,0,1,1.384-.14q.332-.016.667-.016t.668.016a10.354,10.354,0,0,0-.668-1.781,11.161,11.161,0,0,0-.77-1.346,12.051,12.051,0,0,0-.852-1.126,16.4,16.4,0,0,0-11.518-5.327q-.578-.035-1.168-.035"
                        transform="translate(-209.03 -204.681)"
                        fill="#e85317"
                    />
                    <path
                        d="M351.857,345.4a10.688,10.688,0,0,0-9.463,10.627,10.793,10.793,0,0,0,.108,1.518,10.687,10.687,0,0,0,9.477,9.122c.369-.019.741-.029,1.113-.029s.744.01,1.113.029a10.7,10.7,0,0,0,.122-21.267,10.729,10.729,0,0,0-2.47,0"
                        transform="translate(-306.559 -309.182)"
                        fill="#e85317"
                    />
                    <path
                        d="M306.656,585.225h-.043q-.044-.473-.134-.936a3.993,3.993,0,0,1-.394-.9,11.482,11.482,0,0,0-3.63-5.416,4.014,4.014,0,0,1-.692-.77,17.331,17.331,0,0,0-9.264-3.232q-.578-.035-1.168-.035t-1.168.035A17.33,17.33,0,0,0,280.9,577.2a4.016,4.016,0,0,1-.69.768,11.488,11.488,0,0,0-3.631,5.417,3.991,3.991,0,0,1-.394.9c-.059.309-.1.621-.134.936h-.043l-2.564,11.651a1.224,1.224,0,0,0,1.2,1.487h33.387a1.224,1.224,0,0,0,1.2-1.487Z"
                        transform="translate(-244.798 -513.863)"
                        fill="#e85317"
                    />
                    <path
                        d="M619.518,207.029a10.781,10.781,0,0,0-1.023,1.011,10.7,10.7,0,0,0,6.893,17.732q.556-.028,1.116-.029t1.116.029a10.7,10.7,0,1,0-8.1-18.742"
                        transform="translate(-551.355 -183.037)"
                        fill="#e85317"
                    />
                    <path
                        d="M596.7,455.981l-2.564-11.652H594.1c-.431-4.607-4.068-8.5-9.138-10.273q-.7-.244-1.434-.434-.689-.177-1.406-.3a18.985,18.985,0,0,0-2.131-.249q-.58-.035-1.171-.035t-1.171.035a17.436,17.436,0,0,0-8.938,3,14.212,14.212,0,0,0-1.608,1.308,12.889,12.889,0,0,0-1.208,1.308,10.59,10.59,0,0,0-2.355,5.641h-.044l-.916,4.166a1.363,1.363,0,0,0,.066.8,1.385,1.385,0,0,0,.385.538,14.044,14.044,0,0,1,4.438,6.663,1.36,1.36,0,0,0,.326.561,1.339,1.339,0,0,0,.965.411H595.51a1.224,1.224,0,0,0,1.195-1.487"
                        transform="translate(-503.667 -387.713)"
                        fill="#e85317"
                    />
                    <path
                        d="M74.6,224.548a10.652,10.652,0,0,0,3.964,1.223q.556-.028,1.117-.029t1.116.029a10.7,10.7,0,1,0-6.2-1.223"
                        transform="translate(-61.761 -183.037)"
                        fill="#e85317"
                    />
                    <path
                        d="M29.27,456.495a14.05,14.05,0,0,1,4.438-6.664,1.384,1.384,0,0,0,.384-.537,1.363,1.363,0,0,0,.067-.8l-.916-4.165H33.2a10.591,10.591,0,0,0-2.355-5.641,12.873,12.873,0,0,0-1.208-1.308,14.2,14.2,0,0,0-1.608-1.308,17.435,17.435,0,0,0-8.938-3q-.58-.035-1.171-.036t-1.171.036a18.994,18.994,0,0,0-2.131.249q-.716.125-1.406.3-.734.189-1.434.434c-5.07,1.771-8.707,5.666-9.138,10.272H2.593L.029,455.98a1.224,1.224,0,0,0,1.195,1.486H27.979a1.339,1.339,0,0,0,.965-.411,1.359,1.359,0,0,0,.326-.561"
                        transform="translate(0 -387.712)"
                        fill="#e85317"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
};